import {mande} from 'mande'
import {defineStore} from 'pinia'

const post_pledge = mande('/pledges')
const post_results = mande('/results')

export const surveyStore = defineStore('survey', {
  state: () => ({
    step: 'UserInfo',
    bar_length: '50%',
    currentTransition: 'next',
    error_msg: '',
    name: '',
    title: '',
    company: '',
    email: '',
    phone: '+',
    country: '',
    company_role: '',
    pledge_self_or_company: '',
    sf_partner_or_customer: [],
    pillars: [],
    number_of_social_posts: '',
    committed_hours: '',
    donation: '',
    what_cause: '',
    how_will_you_support: [],
    response: '',
    how_did_you_hear: '',
    share_permission: false
  }),

  actions: {
    async submit(type) {
      let salesforce_company = this.sf_partner_or_customer.join(',')
      let my_support = this.how_will_you_support.join(',')
      let my_pillars = this.pillars.join(',')
      let form_data = {
        name: this.name,
        title: this.title,
        company: this.company,
        email: this.email,
        phone: this.phone,
        country: this.country,
        company_role: this.company_role,
        sf_partner_or_customer: salesforce_company,
        pillars: my_pillars,
        number_of_social_posts: this.number_of_social_posts,
        committed_hours: this.committed_hours,
        donation: this.donation,
        pledge_self_or_company: this.pledge_self_or_company,
        what_cause: this.what_cause,
        how_will_you_support: my_support,
        how_did_you_hear: this.how_did_you_hear,
        share_permission: this.share_permission
      }
      try {
        this.response = await post_pledge.post({pledge: form_data}).then((response) => {
          console.log(response)
          if (response.response === 'fail') {
            this.error_msg = 'Something went wrong. (Email may have already submitted a pledge.) Please go back and try again.'
          } else {
            window.location.href = '/pledge/confirmation';
          }
        })
      } catch (error) {
        this.error_msg = 'Something went wrong. (Email may have already submitted a pledge.) Please go back and try again.'
        console.log(error)
        // let the form component display the error
        return error
      }
    },
  },
})

export const resultsStore = defineStore('results', {
  state: () => ({
    step: 'ResultsUserInfo',
    bar_length: '50%',
    currentTransition: 'next',
    error_msg: '',
    name: '',
    title: '',
    company: '',
    email: '',
    phone: '+',
    country: '',
    company_role: '',
    results_self_or_company: '',
    sf_partner_or_customer: [],
    pillars: '',
    number_of_social_posts: '',
    committed_hours: '',
    donation: '',
    tell_us_more: '',
    share_permission: false
  }),

  actions: {
    async submit(type) {
      let salesforce_company = this.sf_partner_or_customer.join(',')
      let my_pillars = this.pillars.join(',')
      let form_data = {
        name: this.name,
        title: this.title,
        company: this.company,
        email: this.email,
        phone: this.phone,
        country: this.country,
        company_role: this.company_role,
        sf_partner_or_customer: salesforce_company,
        results_self_or_company: this.results_self_or_company,
        pillars: my_pillars,
        number_of_social_posts: this.number_of_social_posts,
        committed_hours: this.committed_hours,
        donation: this.donation,
        pledge_self_or_company: this.pledge_self_or_company,
        tell_us_more: this.tell_us_more,
        share_permission: this.share_permission
      }
      try {
        this.response = await post_results.post({results: form_data}).then((response) => {
          console.log(response)
          if (response.response === 'fail') {
            this.error_msg = 'Something went wrong. (Email may have already submitted results.) Please go back and try again.'
          } else {
            window.location.href = '/results/confirmation';
            // this.step = 'ResultsConfirmation'
          }
        })
      } catch (error) {
        this.error_msg = 'Something went wrong. (Email may have already submitted results.) Please go back and try again.'
        console.log(error)
        // let the form component display the error
        return error
      }
    },
  },
})